import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

interface IProps {
    isActive: boolean;
    onClick: () => void;
    itemCount: number;
    text: string;
    icon?: ReactNode;
}

const TagFilterPill: FC<IProps> = ({ isActive, onClick, itemCount, text, icon }) => {
  const pillClassName = cx(
    'inline-flex gap-1.5 items-center cursor-pointer bg-brand_faint-blue ring-1 ring-brand_grey h-8 leading-8 rounded-full text-xs px-2.5',
    {
      selected: isActive,
      'ring-0 bg-brand_secondary text-white': isActive,
      // red: !IsTagPublishWebsite, -- TODO: find the intent behind this. The className isn't doing anything
    }
  );

  const pillItemCountClassName = cx(
    'leading-none text-2xs rounded-md py-1 p-1.5',
    {
      'bg-brand_secondary text-white': !isActive,
      'bg-white text-brand_secondary': isActive,
    }
  );

  return (
      <button type="button" className={pillClassName} onClick={onClick}>
        {icon}
        {text} <span className={pillItemCountClassName}>{itemCount}</span>
      </button>
  );
};

export { TagFilterPill };
